import { render, staticRenderFns } from "./MeusDados.vue?vue&type=template&id=3986702c&scoped=true"
import script from "./MeusDados.vue?vue&type=script&lang=js"
export * from "./MeusDados.vue?vue&type=script&lang=js"
import style0 from "./MeusDados.vue?vue&type=style&index=0&id=3986702c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3986702c",
  null
  
)

export default component.exports